<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TimelineDetailFundAuditDrawer',
})
</script>
<template>
  <Drawer v-model:visible="visible" title="详情" width="1000px" destroyOnClose>
    <Skeleton :loading="loading" active :paragraph="{ rows: 10 }"> <Detail :record="result" :projectId="projectId" /> </Skeleton>
  </Drawer>
</template>

<script lang="ts" setup name="TimelineDetailFundAuditDrawer">
import { Drawer, Skeleton } from 'ant-design-vue'
import { ref } from 'vue'
import { API_FUND_AUDIT_DETAIL } from '@/api/fundAudit'
import { useFetch } from '@/hooks/useFetch'
import Detail from './index.vue'

const visible = ref(false)
const { result, loading, fetchData } = useFetch({
  getFn: API_FUND_AUDIT_DETAIL,
  isShallow: true
})

const projectId = ref<string>()
const open = (id: string, _projectId: string) => {
  visible.value = true
  fetchData(id)
  projectId.value = _projectId
}
defineExpose({
  open,
  result
})
</script>
